<template>
  <div class="MdBx" :class="layoutClass" :style="boxStyle">
    <template v-for="(element,index) in data.contents">
      <box-element
        v-if="element.type === 'box'"
        :key="uid+ '-box' + index"
        :data="element"
        :uid="uid+ '-box' + index"
      />
      <icon-element
        v-else-if="element.type === 'icon'"
        :key="uid + '-icon' + index"
        :data="element"/>
      <text-element
        v-else-if="element.type === 'text'"
        :key="uid + '-text' + index"
        :uid="uid + '-text' + index"
        :data="element"/>
      <button-element
        v-else-if="element.type === 'button'"
        :key="uid + '-btn' + index"
        :data="element"/>
      <image-element
        v-else-if="element.type === 'image'"
        :key="uid + '-img' + index"
        :data="element"/>
      <div class="fl0 MdSep"
           :key="uid + '-sep' + index"
           v-else-if="element.type === 'separator'"></div>
      <div class="mdBxFiller"
           :key="uid + '-fill' + index"
           v-else-if="element.type === 'filler'"></div>
      <div class="box-gfe"
           :key="uid + '-else' + index"
           v-else>
        {{element.type}}
      </div>
    </template>
  </div>
</template>
<script>
import TextElement from './TextElement.vue';
import ButtonElement from './ButtonElement.vue';
import ImageElement from './ImageElement.vue';
import IconElement from './IconElement.vue';

export default {
  name: 'logLineBoxElement',
  components: {
    'text-element': TextElement,
    'button-element': ButtonElement,
    'image-element': ImageElement,
    'icon-element': IconElement,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    uid: {
      type: String,
      default: '',
    },
  },
  computed: {
    layoutClass() {
      return {
        hr: this.data.layout === 'horizontal',
        vr: this.data.layout === 'vertical',
        'hr bl': this.data.layout === 'baseline',
        spcXs: this.data.spacing === 'xs',
        spcSm: this.data.spacing === 'sm',
        spcMd: this.data.spacing === 'md',
        spcLg: this.data.spacing === 'lg',
        spcXl: this.data.spacing === 'xl',
        spcXXl: this.data.spacing === 'xxl',
        fl0: this.data.flex === 0 || (!this.data.flex && this.data.width),
        fl1: this.data.flex === 1,
        fl2: this.data.flex === 2,
        fl3: this.data.flex === 3,
        ExAbs: this.data.position === 'absolute',
        ExMgnTXs: this.data.margin === 'xs',
        ExMgnTSm: this.data.margin === 'sm',
        ExMgnTMd: this.data.margin === 'md',
        ExMgnTLg: this.data.margin === 'lg',
        ExMgnTXl: this.data.margin === 'xl',
        ExMgnTXXl: this.data.margin === 'xxl',
      };
    },
    boxStyle() {
      const style = {};
      if (this.data.width) style.width = `${this.data.width}!important`;
      if (this.data.height) style.height = `${this.data.height}!important`;
      if (this.data.backgroundColor) style.backgroundColor = this.data.backgroundColor;
      if (this.data.borderWidth) {
        style.borderWidth = this.data.borderWidth;
        style.borderStyle = 'solid';
      }
      if (this.data.borderColor) style.borderColor = this.data.borderColor;
      if (this.data.cornerRadius) style.borderRadius = this.data.cornerRadius;
      if (this.data.offsetTop) style.top = this.data.offsetTop;
      if (this.data.offsetBottom) style.bottom = this.data.offsetBottom;
      if (this.data.offsetStart) style.left = this.data.offsetStart;
      if (this.data.offsetEnd) style.right = this.data.offsetEnd;
      if (this.data.paddingAll) {
        style.paddingLeft = this.data.paddingAll;
        style.paddingRight = this.data.paddingAll;
        style.paddingTop = this.data.paddingAll;
        style.paddingBottom = this.data.paddingAll;
      }
      if (this.data.paddingTop) style.paddingTop = this.data.paddingTop;
      if (this.data.paddingBottom) style.paddingBottom = this.data.paddingBottom;
      if (this.data.paddingStart) style.paddingLeft = this.data.paddingStart;
      if (this.data.paddingEnd) style.paddingRight = this.data.paddingEnd;
      return style;
    },
  },
};
</script>
